import { createContext } from "react";

export const SearchbarContext = createContext({});